import React from 'react'

import { useDashboard } from '@/hooks'

export interface CopyProps {
  onClose: () => void
  onSuccess: (slug: string) => void
}

const Copy: React.FC<CopyProps> = ({ onClose, onSuccess }) => {
  const dashboardContext = useDashboard()
  const currentDashboard = dashboardContext.currentDashboard
  const [title, setTitle] = React.useState(`${currentDashboard.title} (copy)`)
  const [working, setWorking] = React.useState(false)

  const handleCopy = async () => {
    setWorking(true)
    const copiedDashboard = {
      ...currentDashboard,
      title,
      slug: '',
      isDefault: false,
    }
    const dashboard = await dashboardContext.addDashboard({
      dashboard: copiedDashboard,
      insights: currentDashboard.insights,
    })
    setWorking(false)
    onSuccess(dashboard.slug)
  }
  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 p-6">
        <div className="space-y-4 mb-4">
          <h3 className="text-lg font-medium">Copy Dashboard</h3>
          <p className="text-gray-600">
            Create a copy of &quot;{currentDashboard.title}&quot; with all its insights and settings.
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <label className="font-medium">Name of Copy</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter new dashboard title "
            className="input input-bordered text-base border-base-300 w-full focus:outline-none focus:border-primary/30"
            onFocus={(e) => e.target.select()}
            autoFocus
          />
        </div>
      </div>

      <div className="border-t border-base-300 p-4 flex gap-2 justify-end">
        <button onClick={onClose} className="btn btn-ghost">
          Cancel
        </button>
        <button onClick={handleCopy} className="btn btn-primary" disabled={working}>
          {working ? 'Creating...' : 'Create Copy'}
        </button>
      </div>
    </div>
  )
}

export default Copy
